import {displayQuantity as qty} from './materialIssueApi';
export default function HandoverStockSummary({line, items}) {
  const item=items.find(i=>String(i.id)===String(line.item_id));
  if(!item)return null;
  const available=Number(item.available_stock||0), issued=Number(line.quantity||0), remaining=available-issued;
  return <div className="col-span-full grid grid-cols-3 gap-3 rounded-lg bg-black/25 p-3 text-sm" aria-live="polite">
    <div className="text-gray-400">Available stock<strong className="block text-white">{qty(available)} {line.unit}</strong></div>
    <div className="text-gray-400">Handover quantity<strong className="block text-amber-300">{qty(issued)} {line.unit}</strong></div>
    <div className="text-gray-400">Remaining stock<strong className={`block ${remaining<0?'text-red-300':'text-emerald-300'}`}>{qty(remaining)} {line.unit}</strong></div>
    {remaining<0&&<p role="alert" className="col-span-full text-red-300">Handover exceeds available stock. Reduce the quantity.</p>}
    <p className="col-span-full text-xs text-gray-500">Available excludes reserved and expired lots. Stock is rechecked and transferred when confirmed.</p>
  </div>;
}
